var _g, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinkingPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 200",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 36,
    rx: 28,
    ry: 18,
    fill: "#fafcfb",
    fillOpacity: 0.14,
    stroke: "#38bdf8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 34,
    rx: 14,
    ry: 11,
    fill: "#fafcfb",
    fillOpacity: 0.1,
    stroke: "#38bdf8",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132,
    cy: 32,
    rx: 12,
    ry: 10,
    fill: "#fafcfb",
    fillOpacity: 0.1,
    stroke: "#38bdf8",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 36c6-8 16-8 22 0M112 42c4-5 10-5 14 0",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 28,
    r: 2.6,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 54,
    r: 4.2,
    fill: "#fafcfb",
    fillOpacity: 0.12,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 64,
    r: 2.6,
    fill: "#fafcfb",
    fillOpacity: 0.12,
    stroke: "#fbbf24",
    strokeWidth: 1.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 188c6-34 22-52 52-52s46 18 52 52",
    fill: "#fafcfb",
    fillOpacity: 0.12,
    stroke: "#38bdf8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 148c8 10 18 16 28 16s20-6 28-16",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118c4 10 12 16 16 16s12-6 16-16",
    fill: "#fafcfb",
    fillOpacity: 0.18,
    stroke: "#38bdf8",
    strokeWidth: 1.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 88,
    rx: 34,
    ry: 40,
    fill: "#fafcfb",
    fillOpacity: 0.22,
    stroke: "#38bdf8",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80c4-28 22-42 42-40 14 2 26 14 30 30-8-10-20-16-34-16-16 0-28 8-38 26z",
    fill: "#38bdf8",
    fillOpacity: 0.35,
    stroke: "#38bdf8",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86c2 2 4 2 6 0",
    stroke: "#38bdf8",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86c2 2 4 2 6 0",
    stroke: "#38bdf8",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76 102c4 4 10 4 14 0",
    stroke: "#fbbf24",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 96c-2 10 2 22 10 28",
    stroke: "#38bdf8",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkingPerson);
export default __webpack_public_path__ + "static/media/thinking-person.1e38491675a7c3ab5aa88c0680e9fa50.svg";
export { ForwardRef as ReactComponent };